import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PhoneAuthStateService } from '../services/phone-auth-state.service';
import { ControllerService } from '../services/controller/controller.service';

/**
 * Guard that ensures the user has completed the phone sign-in flow
 * before accessing the verify-phone-code page.
 * Redirects to phone-sign-in if no confirmation result exists.
 */
export const phoneVerificationCanActivateGuard: CanActivateFn = (): boolean | UrlTree => {
  const phoneAuthStateService = inject(PhoneAuthStateService);
  const router = inject(Router);
  const controllerService = inject(ControllerService);

  const sessionId = phoneAuthStateService.getSessionId();
  const phoneNumber = phoneAuthStateService.getPhoneNumber();

  if (sessionId && phoneNumber) {
    // Valid session ID exists - allow access
    return true;
  }

  // No session ID - redirect to phone sign-in
  console.warn('Phone verification guard: Missing session ID - redirecting to phone sign-in');

  // Redirect to phone sign-in page (no toast)
  return router.createUrlTree(['/phone-sign-in']);
};
